import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import TenantActions from '@Actions/tenantActions';
import dayjs from 'dayjs';
import {
  DatePicker, Checkbox, Select, Alert,
} from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import { toISTDate } from '@Apis/constants';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const InitialImport = ({
  user, getShopifyConnections, shopifyConnections, connectTenantToShopifyLocation, connectTenantToShopifyLocationLoading, setStep, getShopifyConnectionsLoading, getTenants, tenants,
}) => {
  const [isSyncProducts, setIsSyncProducts] = useState('');
  const [isSyncCustomers, setIsSyncCustomers] = useState('');
  const [isSyncOrders, setIsSyncOrders] = useState('');
  // const [isSyncOrdersDate, setIsSyncOrdersDate] = useState('');
  const [isSyncFulfillments, setIsSyncFulfillments] = useState('');
  const [isSyncRefunds, setIsSyncRefunds] = useState('');
  const [isCreateCustomItems, setIsCreateCustomItems] = useState('');
  const [selectedTenantIds, setSelectedTenantIds] = useState('');
  const [formSubmitted, setFormSubmitted] = useState('');
  const [startShopifySyncAfter, setStartShopifySyncAfter] = useState(dayjs());

  useEffect(() => {
    getTenants(1, '', true, user?.tenant_info?.org_id);
    getShopifyConnections(user?.tenant_info?.org_id, (data) => {
      const configurationData = data?.find((connection) => connection?.is_connected)?.configuration;
      if (configurationData) {
        setIsSyncProducts(configurationData?.sync_products);
        setIsSyncCustomers(configurationData?.sync_customers);
        setIsSyncOrders(configurationData?.sync_orders);
        // setIsSyncOrdersDate(configurationData?.sync_orders_date);
        setIsSyncFulfillments(configurationData?.sync_fulfillment);
        setIsSyncRefunds(configurationData?.sync_refunds);
        setIsCreateCustomItems(configurationData?.create_custom_item);
        setSelectedTenantIds(configurationData?.default_tenant_id);
        setStartShopifySyncAfter(configurationData?.start_shopify_sync_after ? configurationData?.start_shopify_sync_after : dayjs());
      }
    });
  }, []);

  const shopName = shopifyConnections?.find((connection) => connection?.is_connected)?.shop_name;

  const tenantIntegrations = shopifyConnections?.find((connection) => connection?.is_connected)?.tenant_integrations;

  const oldConfiguration = shopifyConnections?.find((connection) => connection?.is_connected)?.configuration;

  const productSyncEndAt = shopifyConnections?.[0]?.product_sync_end_at;

  const productSyncAt = shopifyConnections?.[0]?.product_sync_at;

  const handleSubmit = () => {
    setFormSubmitted(true);
    if (selectedTenantIds) {
      const payload = {
        org_id: user?.tenant_info?.org_id,
        shop_name: shopName,
        default_tenant_id: selectedTenantIds,
      };

      const configuration = {
        ...oldConfiguration,
        sync_products: isSyncProducts,
        sync_customers: isSyncCustomers,
        sync_orders: isSyncOrders,
        // sync_orders_date: isSyncOrdersDate,
        sync_fulfillment: isSyncFulfillments,
        sync_refunds: isSyncRefunds,
        create_custom_item: isCreateCustomItems,
        default_tenant_id: selectedTenantIds,
        start_shopify_sync_after: startShopifySyncAfter,
      };

      payload.tenant_integrations = tenantIntegrations;
      payload.configuration = configuration;

      connectTenantToShopifyLocation(payload, () => {
        setStep(3);
      });
    }
  };

  return (
    <Fragment>
      { getShopifyConnectionsLoading
        ? (
          <div className="shopify-integration__loader__wrapper">

            { [...Array(5).keys()].map((item) => (
              <div key={item} className="shopify-integration__loader-row">
                <div className="loadingBlock  shopify-integration__loader__line1" />
                <div className="loadingBlock  shopify-integration__loader__line2" />
                <div className="loadingBlock  shopify-integration__loader__line3" />
              </div>
            ))}
            <div className="loadingBlock shopify-integration__loader__line-btn1" />
            <div className="loadingBlock shopify-integration__loader__line-btn2" />
          </div>
        )
        : (
          <div className="shopify__import-wrapper">

            <div className="shopify__import-header">
              Data import during first-time connect
            </div>

            <div className="shopify__import-entity">
              <div className="shopify__import-entity-info">
                Procuzy can import all customers and products from Shopify to Procuzy.
                {/* Please Choose your preferences below. */}
              </div>
              <div className="shopify__import-check">
                <Checkbox
                  checked={isSyncProducts}
                  onChange={(e) => {
                    setIsSyncProducts(e.target.checked);
                  }}
                  disabled={connectTenantToShopifyLocationLoading || !!productSyncAt}
                >
                  Yes, Import all Products.
                  {' '}
                  <span className="shopify__import-check-text">
                    {productSyncEndAt && `(Product last sync at ${toISTDate(productSyncEndAt).format('DD/MM/YYYY hh:mm A')})`}
                  </span>
                </Checkbox>
              </div>
              {/* <div className="shopify__import-check"> */}
              {/*  <Checkbox */}
              {/*    checked={isSyncCustomers} */}
              {/*    onChange={(e) => { */}
              {/*      setIsSyncCustomers(e.target.checked); */}
              {/*    }} */}
              {/*    disabled={connectTenantToShopifyLocationLoading} */}
              {/*  > */}
              {/*    Yes, Import all Customers. */}
              {/*  </Checkbox> */}
              {/* </div> */}
            </div>

            <div className="shopify__import-entity">
              {/* <div className="shopify__import-entity-info">
                Procuzy will also import your open orders together with associated customers and products from Shopify to Procuzy.
                All “Paid” orders are imported by default, but you can opt-out of importing your “Payment pending” orders or custom items as products.
              </div> */}
              <div className="shopify__import-check-wrapper">
                {/* <div className="shopify__import-check"> */}
                {/*  <Checkbox */}
                {/*    checked={isSyncOrders} */}
                {/*    onChange={(e) => { */}
                {/*      setIsSyncOrders(e.target.checked); */}
                {/*      if (e.target.checked === false) { */}
                {/*        setIsSyncFulfillments(false); */}
                {/*        setIsSyncRefunds(false); */}
                {/*      } */}
                {/*    }} */}
                {/*    disabled={connectTenantToShopifyLocationLoading} */}
                {/*  > */}
                {/*    Import historical orders. */}
                {/*  </Checkbox> */}
                {/* </div> */}
                {isSyncOrders && (
                  <div className="shopify__import-inner-check">
                    <div className="shopify__import-check">
                      <Checkbox
                        checked={isSyncFulfillments}
                        onChange={(e) => {
                          setIsSyncFulfillments(e.target.checked);
                        }}
                        disabled={connectTenantToShopifyLocationLoading}
                      >
                        Import order Fulfillment as Invoice on Procuzy.
                      </Checkbox>
                    </div>
                    <div className="shopify__import-check">
                      <Checkbox
                        checked={isSyncRefunds}
                        onChange={(e) => {
                          setIsSyncRefunds(e.target.checked);
                        }}
                        disabled={connectTenantToShopifyLocationLoading || !isSyncFulfillments}
                      >
                        Import Refunds as Credit Notes on Procuzy.
                      </Checkbox>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* <div className="shopify__import-entity">
              <div className="shopify__import-check">
                <Checkbox
                  checked
                  disabled
                />
                <span style={{ marginLeft: '8px' }}>Customer will be created during order sync if not existed in procuzy.</span>
              </div>
            </div> */}
            {/* <div className="shopify__import-entity" style={{ marginBottom: '10px' }}>
              <div className="shopify__import-check">
                <Checkbox
                  checked={isCreateCustomItems}
                  onChange={(e) => {
                    setIsCreateCustomItems(e.target.checked);
                  }}
                  disabled={connectTenantToShopifyLocationLoading}
                >
                  Custom items as new product on Shopify(if unchecked these order lines will be discarded)
                </Checkbox>
              </div>
            </div> */}

            <div className="shopify__import-selector">
              <div>
                <PRZSelect
                  value={selectedTenantIds}
                  filterOption={false}
                  disabled={connectTenantToShopifyLocationLoading}
                  placeholder="Select Default Location"
                  onChange={(value) => { setSelectedTenantIds(value); }}
                  style={{
                    border: 'none',
                    borderBottom: (formSubmitted && !selectedTenantIds) ? '1px solid rgba(255, 99, 71, 0.5) ' : '1px solid rgba(68, 130, 218, 0.2)',
                    width: '180px',
                    fontSize: '13px',
                    marginRight: '10px',
                  }}
                  showSearch
                >
                  {tenants?.data?.filter((item) => item?.shopify_location_id)?.map((tenant) => (
                    <Option key={tenant?.tenant_id} value={tenant?.tenant_id}>
                      {tenant?.tenant_name}
                    </Option>
                  ))}
                </PRZSelect>
              </div>
              <div style={{ fontSize: '13px' }}>
                Select a default Procuzy location where all your Shopify orders will be created.
                <span className="input-error">*</span>
              </div>
            </div>

            <div className="shopify__import-date-selector">
              <div>
                <DatePicker
                  value={dayjs(new Date(startShopifySyncAfter))}
                  onChange={(value) => {
                    setStartShopifySyncAfter(value);
                  }}
                  style={{
                    border: 'none',
                    borderBottom: (formSubmitted && !startShopifySyncAfter) ? '1px solid rgba(255, 99, 71, 0.5) ' : '1px solid rgba(45, 125, 247, 0.25)',
                    height: '32px',
                    width: '180px',
                    fontSize: '13px',
                    marginRight: '10px',
                    marginTop: '0px',
                    marginBottom: '10px',
                    padding: '4px 10px 4px 4px',
                  }}
                />
              </div>
              <div style={{ fontSize: '13px' }}>
                Only fulfillments which are created in shopify after this date will be synced to procuzy.
                <span className="input-error">*</span>
              </div>
            </div>

            <div className="shopify__import-warning">
              <Alert
                message="Orders which have custom products will be discarded."
                type="info"
                showIcon
                className=""
              />
            </div>

            <div className="ant-row">
            &nbsp;&nbsp;
              <H3Button
                text="Back"
                buttonType={defaultButtonTypes.BLUE_BORDERED}
                onClick={() => setStep(1)}
                customClass="shopify__import-submit"
                disabled={connectTenantToShopifyLocationLoading}
              />
              &nbsp;&nbsp;
              <H3Button
                text="Next Step"
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                onClick={() => handleSubmit()}
                customClass="shopify__import-submit"
                isLoading={connectTenantToShopifyLocationLoading}
                disabled={connectTenantToShopifyLocationLoading}
              />
            </div>
          </div>
        )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, ShopifyIntegrationReducers, TenantReducers }) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  shopifyConnections: ShopifyIntegrationReducers.shopifyConnections,
  connectTenantToShopifyLocationLoading: ShopifyIntegrationReducers.connectTenantToShopifyLocationLoading,
  getTenantsLoading: TenantReducers.getTenantsLoading,
});
const mapDispatchToProps = (dispatch) => ({
  getShopifyConnections: (orgId, callback) => dispatch(ShopifyIntegrationActions.getShopifyConnections(orgId, callback)),
  connectTenantToShopifyLocation: (payload, callback) => dispatch(ShopifyIntegrationActions.connectTenantToShopifyLocation(payload, callback)),
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
});

InitialImport.propTypes = {
  user: PropTypes.any,
  getShopifyConnectionsLoading: PropTypes.bool,
  getShopifyConnections: PropTypes.func,
  connectTenantToShopifyLocation: PropTypes.func,
  connectTenantToShopifyLocationLoading: PropTypes.bool,
  shopifyConnections: PropTypes.any,
  tenants: PropTypes.any,
  setStep: PropTypes.func,
  getTenants: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InitialImport));
